<template>
  <header class="header">
    <div class="exitblock" @click="showModal(7)"></div>
    <div class="container">
      <div class="header__wrapper">
        <router-link to="/" class="header__logo"><img src="/static/assets/img/header/logo.svg" alt="SMART.юрист" /></router-link>
        <div class="header__burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="header__menu menu">
          <ul class="menu__list">
            <li><router-link to="/videos" class="header__link">Популярные видеоуроки</router-link></li>
            <li><router-link to="/free" class="header__link">Бесплатные уроки</router-link></li>
            <li><router-link to="/how-it-works" class="header__link">Как это работает</router-link></li>
            <li><router-link to="/education" class="header__link">Как происходит обучение</router-link></li>
            <li><router-link to="/wins" class="header__link">Выигранные дела</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Header',
  data () {
    return {
      url: null
    }
  },
  created () {
    this.url = this.$router.currentRoute.path
  },
  methods: {
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  },
  watch: {
    $route (to, from) {
      this.url = to.path
    }
  },
  mounted () {
    $('#nav_toggle').on('click', function (event) {
      event.preventDefault()

      $(this).toggleClass('active')
      $('#nav').toggleClass('active')
    })
    $(document).ready(function () {
      $('.header__burger').click(function (event) {
        $('.header__burger,.header__menu').toggleClass('active')
        $('body').toggleClass('lock')
      })
    })
  },
  computed: {
    white () {
      return ((this.url === '' || this.url === '/' || this.url === '/who-needs' || this.url === '/how-it-works' || this.url === '/all' || this.$route.name === 'program' || this.$route.name === 'group') ? 1 : 0)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/include/header.vue